var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5625C0 0.250781 0.250781 0 0.5625 0H8.4375C8.74922 0 9 0.250781 9 0.5625C9 0.874219 8.74922 1.125 8.4375 1.125H8.25V1.57031C8.25 2.51484 7.875 3.42188 7.20703 4.08984L5.29453 6L7.20469 7.91016C7.875 8.57812 8.25 9.48516 8.25 10.4297V10.875H8.4375C8.74922 10.875 9 11.1258 9 11.4375C9 11.7492 8.74922 12 8.4375 12H0.5625C0.250781 12 0 11.7492 0 11.4375C0 11.1258 0.250781 10.875 0.5625 10.875H0.75V10.4297C0.75 9.48516 1.125 8.57812 1.79297 7.91016L3.70547 6L1.79297 4.08984C1.125 3.42188 0.75 2.51484 0.75 1.57031V1.125H0.5625C0.250781 1.125 0 0.874219 0 0.5625ZM2.58984 8.70703C2.49844 8.79844 2.41406 8.89688 2.33906 9H6.66094C6.58594 8.89688 6.50156 8.79844 6.41016 8.70703L4.5 6.79453L2.58984 8.70469V8.70703ZM6.66094 3C6.96094 2.5875 7.125 2.08594 7.125 1.57031V1.125H1.875V1.57031C1.875 2.08828 2.03906 2.5875 2.33906 3H6.66094Z",
    fill: "#149CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending_icon.c1540a51f07fe962910665c7f94c4361.svg";
export { ForwardRef as ReactComponent };